<template>
  <div class="cell-wrapper" @click="$emit('click')">
    <div class="cell-title">
      <UserAvatar :src="user.avatar" :shape="shape" />
      <span class="user-name text-ellipsis" :data-id="user.userId">{{ initFriendName(user) }}</span>
      <!-- <span :data-id="user.userId">{{user.name}}</span>
      <span v-if="user.remark">({{user.remark}})</span>-->
    </div>
  </div>
</template>

<script>
import UserAvatar from "./UserAvatar";
export default {
  name: "cell-cell",
  props: {
    user: Object,
  },
  data() {
    return {
      shape: "terse",
    };
  },
  components: {
    UserAvatar,
  },
  methods: {
    initFriendName(friend) {
      if (friend.remark) {
        return `${friend.name}(${friend.remark})`;
      } else {
        return `${friend.name}`;
      }
    },
  },
};
</script>
<style scoped>
.cell-wrapper {
  margin-bottom: 7px;
}

.cell-wrapper:last-child {
  margin-bottom: 0;
}

.cell-wrapper .cell-title {
  display: flex;
  align-items: center;
  margin: 3px 0;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-wrapper:hover span {
  color: #409eff;
  cursor: pointer;
}

.cell-title .avatar-box {
  margin-right: 10px;
}

.cell-title .user-name {
  max-width: 250px;
}
</style>